module.exports = __webpack_public_path__ + "img/wz-5-14.045031ae.png";